export class Heap {
    size = 0; 
    hp = 0; 
    lista = null; 

    constructor(size, hp){
        this.size = size; 
        this.hp = hp;
        this.lista = []; 
    }
}